import { render } from "./BaseRecipesCatalog.vue?vue&type=template&id=f3111678&scoped=true"
import script from "./BaseRecipesCatalog.vue?vue&type=script&lang=js"
export * from "./BaseRecipesCatalog.vue?vue&type=script&lang=js"

import "./BaseRecipesCatalog.vue?vue&type=style&index=0&id=f3111678&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3111678"]])

export default __exports__